import { defineMessages, IntlShape } from "react-intl";

export const commonMessages = defineMessages({
  accessPageDescription: {
    defaultMessage: "Short Description"
  },
  accountInformations: {
    defaultMessage: "Account Information"
  },
  agreement: {
    defaultMessage: "Agree to the SM Malls Online Seller Agreement"
  },
  availability: {
    defaultMessage: "Availability"
  },
  catalog: {
    defaultMessage: "Catalog"
  },
  categoryUploadError: {
    defaultMessage: "File not supported"
  },
  clusterDetails: {
    defaultMessage: "Cluster Details"
  },
  collectionUploadError: {
    defaultMessage: "File not supported"
  },
  companyName: {
    defaultMessage: "Company Name"
  },
  contactNumber: {
    defaultMessage: "Contact Number"
  },
  content: {
    defaultMessage: "Content"
  },
  customApps: {
    defaultMessage: "Local Apps"
  },
  dashboard: {
    defaultMessage: "Dashboard"
  },
  demo: {
    defaultMessage:
      "Just to let you know... You're in demo mode. You can play around with the dashboard but can't save changes.",
    description: "notification message after log in"
  },
  description: {
    defaultMessage: "Description"
  },
  discounts: {
    defaultMessage: "Discounts"
  },
  drafts: {
    defaultMessage: "Drafts"
  },
  email: {
    defaultMessage: "Email Address"
  },
  endDate: {
    defaultMessage: "End Date"
  },
  endHour: {
    defaultMessage: "End Hour"
  },
  firstName: {
    defaultMessage: "First Name"
  },
  generalInformations: {
    defaultMessage: "General Information"
  },
  homeAddressBrgy: {
    defaultMessage: "Home #, Street, Subdivision, Brgy"
  },
  homeAddressCity: {
    defaultMessage: "City"
  },
  homeAddressProvince: {
    defaultMessage: "Province"
  },
  homeAddressZipCode: {
    defaultMessage: "Zip Code"
  },
  lastName: {
    defaultMessage: "Last Name"
  },
  mainPromoDescription: {
    defaultMessage: "Main Promo Description"
  },
  mallBranch: {
    defaultMessage: "Mall Branch"
  },
  mechanics: {
    defaultMessage: "Mechanics"
  },
  no: {
    defaultMessage: "No"
  },
  optionalField: {
    defaultMessage: "Optional",
    description: "field is optional"
  },
  otpResend: {
    defaultMessage: "Successfully re-send OTP!"
  },
  productInformation: {
    defaultMessage: "Product Information"
  },
  properties: {
    defaultMessage: "Properties"
  },
  readOnly: {
    defaultMessage: "Saleor runs in read-only mode. Changes not saved."
  },
  requiredField: {
    defaultMessage: "This field is required"
  },
  saveChanges: {
    defaultMessage: "Save changes"
  },
  savedChanges: {
    defaultMessage: "Saved changes"
  },
  sessionExpired: {
    defaultMessage: "Your session has expired. Please log in again to continue."
  },

  somethingWentWrong: {
    defaultMessage: "SMOP ran into an unexpected problem"
  },
  startDate: {
    defaultMessage: "Start Date"
  },
  startHour: {
    defaultMessage: "Start Hour"
  },
  status: {
    defaultMessage: "Status"
  },
  storeBrand: {
    defaultMessage: "Store Brand"
  },
  successBusinessDetails: {
    defaultMessage: "Saved Changes"
  },
  successCategoryDeletion: {
    defaultMessage: "Category Deleted"
  },
  successCollectionDeletion: {
    defaultMessage: "Collection Deleted"
  },
  summary: {
    defaultMessage: "Summary"
  },
  timeError: {
    defaultMessage: "Start Time should be earlier than the End Time"
  },
  uploadEmptyError: {
    defaultMessage: "The product file uploaded was empty"
  },
  uploadError: {
    defaultMessage: "A copy of products spreadsheet was sent to your email"
  },
  uploadImage: {
    defaultMessage: "Upload image",
    description: "button"
  },
  yes: {
    defaultMessage: "Yes"
  }
});

export const buttonMessages = defineMessages({
  accept: {
    defaultMessage: "Accept",
    description: "button"
  },
  acknowledge: {
    defaultMessage: "Acknowledge",
    description: "button"
  },
  activate: {
    defaultMessage: "activate",
    description: "button"
  },
  back: {
    defaultMessage: "Back",
    description: "button"
  },
  cancel: {
    defaultMessage: "Cancel",
    description: "button"
  },
  clear: {
    defaultMessage: "Clear",
    description: "button"
  },
  close: {
    defaultMessage: "Close",
    description: "button"
  },
  collect: {
    defaultMessage: "Collected",
    description: "button"
  },
  completed: {
    defaultMessage: "Completed",
    description: "button"
  },
  confirm: {
    defaultMessage: "Confirm",
    description: "button"
  },
  create: {
    defaultMessage: "Create",
    description: "button"
  },
  deactivate: {
    defaultMessage: "Deactivate",
    description: "button"
  },
  delete: {
    defaultMessage: "Delete",
    description: "button"
  },
  discountSubsidy: {
    defaultMessage: "Discount Subsidy",
    description: "subsidy section name"
  },
  done: {
    defaultMessage: "Done",
    description: "button"
  },
  edit: {
    defaultMessage: "Edit",
    description: "button"
  },
  manage: {
    defaultMessage: "Manage",
    description: "button"
  },
  markAsCollected: {
    defaultMessage: "Mark As Collected",
    description: "button"
  },
  nextStep: {
    defaultMessage: "Next",
    description: "go to next step, button"
  },
  ok: {
    defaultMessage: "OK",
    description: "button"
  },
  packed: {
    defaultMessage: "Packed",
    description: "button"
  },
  percentageDiscount: {
    defaultMessage: "Percentage Discount",
    description: "subsidy section name"
  },
  publish: {
    defaultMessage: "Publish",
    description: "publish"
  },
  ready: {
    defaultMessage: "Ready",
    description: "button"
  },
  readyToShip: {
    defaultMessage: "Ready To Ship",
    description: "button"
  },
  receivedAtFc: {
    defaultMessage: "Received at FC",
    description: "button"
  },
  remove: {
    defaultMessage: "Remove",
    description: "button"
  },
  retain: {
    defaultMessage: "Retain",
    description: "button"
  },
  reverseCancellation: {
    defaultMessage: "Reverse Cancellation",
    description: "button"
  },
  saleDiscount: {
    defaultMessage: "Sales Discount",
    description: "subsidy section name"
  },
  save: {
    defaultMessage: "Save",
    description: "button"
  },
  saveChanges: {
    defaultMessage: "Save Changes",
    description: "button"
  },
  saveDraft: {
    defaultMessage: "Save Draft",
    description: "Save Draft button"
  },
  selectAll: {
    defaultMessage: "Select All",
    description: "select all options, button"
  },
  selectProducts: {
    defaultMessage: "Select Products",
    description: "select products, tab"
  },
  send: {
    defaultMessage: "Send",
    description: "button"
  },
  shipped: {
    defaultMessage: "Shipped",
    description: "button"
  },
  show: {
    defaultMessage: "Show",
    description: "button"
  },
  submit: {
    defaultMessage: "Submit",
    description: "button"
  },
  undo: {
    defaultMessage: "Undo",
    description: "button"
  },
  upload: {
    defaultMessage: "Upload",
    description: "button"
  },
  uploadImage: {
    defaultMessage: "Upload Image",
    description: "button"
  },
  yes: {
    defaultMessage: "Yes",
    description: "button"
  }
});

export const sectionNames = defineMessages({
  announcements: {
    defaultMessage: "Announcements",
    description: "announcements section name"
  },
  appConfiguration: {
    defaultMessage: "App configuration",
    description: "application configuration name"
  },
  apps: {
    defaultMessage: "Apps",
    description: "apps section name"
  },
  attributes: {
    defaultMessage: "Attributes",
    description: "attributes section name"
  },
  banners: {
    defaultMessage: "Banners",
    description: "banners section name"
  },
  batch: {
    defaultMessage: "Active Batch",
    description: "batch secion name"
  },
  brands: {
    defaultMessage: "Brands",
    description: "brands section name"
  },
  businessdetails: {
    defaultMessage: "Business Details",
    description: "business details section name"
  },
  categories: {
    defaultMessage: "Categories",
    description: "categories section name"
  },
  categoryStoreType: {
    defaultMessage: "Store Type",
    description: "category store type"
  },
  cluster: {
    defaultMessage: "Clusters",
    description: "clusters section name"
  },
  collections: {
    defaultMessage: "Collections",
    description: "collections section name"
  },
  configuration: {
    defaultMessage: "Configuration",
    description: "configuration section name"
  },
  couponRanking: {
    defaultMessage: "Coupon Ranking",
    description: "coupon ranking section name"
  },
  coupons: {
    defaultMessage: "Coupons",
    description: "coupons section name"
  },
  customers: {
    defaultMessage: "Customers",
    description: "customers section name"
  },
  dispatch: {
    defaultMessage: "Dispatch",
    description: "dispatch section name"
  },
  dispatchHistory: {
    defaultMessage: "Dispatch History",
    description: "dispatch history section name"
  },
  draftOrders: {
    defaultMessage: "Draft Orders",
    description: "draft orders section name"
  },
  dropOff: {
    defaultMessage: "Drop Off",
    description: "drop off section name"
  },
  dropOffManagement: {
    defaultMessage: "Drop Off Management",
    description: "drop off management section name"
  },
  expressFleet: {
    defaultMessage: "Express Fleet",
    description: "express fleet section name"
  },
  fulfillment: {
    defaultMessage: "Fulfillment",
    description: "fulfillment orders name"
  },
  fulfillmentV2: {
    defaultMessage: "Fulfillment v2.0",
    description: "master fulfillment"
  },
  home: {
    defaultMessage: "Home",
    description: "home section name"
  },
  malls: {
    defaultMessage: "Malls",
    description: "mall section name"
  },
  manage_coupons: {
    defaultMessage: "Manage Coupons",
    description: "manage coupon section name"
  },
  merchantSettlement: {
    defaultMessage: "Merchant Settlement Report",
    description: "merchant settlement section name"
  },
  motherOrder: {
    defaultMessage: "Mother Order",
    description: "mother orders name"
  },
  multiFactorAuthentication: {
    defaultMessage: "Multi-Factor Authentication - Activity Logs",
    description: "multi-factor authentication section name"
  },
  navigation: {
    defaultMessage: "Navigation",
    description: "navigation section name"
  },
  orders: {
    defaultMessage: "Orders",
    description: "orders section name"
  },
  pages: {
    defaultMessage: "Pages",
    description: "pages section name"
  },
  paymentEvents: {
    defaultMessage: "Payment Events",
    description: "payment section name"
  },
  permissionGroups: {
    defaultMessage: "Permission Groups",
    description: "permission groups section name"
  },
  plugins: {
    defaultMessage: "Plugins",
    description: "plugins section name"
  },
  productDetails: {
    defaultMessage: "Product Details",
    description: "product details section name"
  },
  productDetailsDimension: {
    defaultMessage: "DIMENSION",
    description: "product details dimension section name"
  },
  productDetailsPricing: {
    defaultMessage: "PRICING PLANS",
    description: "product details pricing plans section name"
  },
  productStatus: {
    defaultMessage: "Product Status",
    description: "product status name"
  },
  productTypes: {
    defaultMessage: "Product Types",
    description: "product types section name"
  },
  products: {
    defaultMessage: "Products",
    description: "products section name"
  },

  remittance: {
    defaultMessage: "Remittance",
    description: "Remittance section name"
  },
  remittanceRunner: {
    defaultMessage: "Remittance Runner",
    description: "Remittance for Runner / Dispatcher section name"
  },
  remittanceRunnerToRemit: {
    defaultMessage: "To Remit",
    description: "To Remit name"
  },
  riderRemittance: {
    defaultMessage: "Rider Remittance",
    description: "rider remittance section name"
  },

  sales: {
    defaultMessage: "Sales",
    description: "sales section name"
  },
  seller: {
    defaultMessage: "Seller",
    description: "Seller section name"
  },
  sellerOrders: {
    defaultMessage: "Seller Orders",
    description: "seller orders section name"
  },
  serviceAccounts: {
    defaultMessage: "Service Accounts",
    description: "service accounts section name"
  },
  shipping: {
    defaultMessage: "Shipping Methods",
    description: "shipping section name"
  },
  siteSettings: {
    defaultMessage: "Site Settings",
    description: "site settings section name"
  },
  staff: {
    defaultMessage: "Staff Members",
    description: "staff section name"
  },
  storeOrder: {
    defaultMessage: "Orders",
    description: "store orders name"
  },

  taxes: {
    defaultMessage: "Taxes",
    description: "taxes section name"
  },
  translations: {
    defaultMessage: "Translations",
    description: "translations section name"
  },
  tripInformation: {
    defaultMessage: "Trip Information",
    description: "trip information section name"
  },
  usertypes: {
    defaultMessage: "User Types",
    description: "user types section name"
  },
  vouchers: {
    defaultMessage: "Vouchers",
    description: "vouchers section name"
  },
  warehouses: {
    defaultMessage: "Warehouses",
    description: "warehouses section name"
  },
  webhooks: {
    defaultMessage: "Webhooks",
    description: "webhooks section name"
  }
});

export const orderFulfillmentEnumNames = {
  ACKNOWLEDGED: "Acknowledged",
  CANCELED: "Cancelled",
  COLLECTED: "Collected",
  COMPLETED: "Completed",
  NEW_ORDER: "New Order",
  PACKED: "PACKED",
  READY: "Ready",
  READY_TO_SHIP: "Ready to Ship",
  RECEIVED_AT_FC: "Received at FC",
  RETURN_TO_FC: "Returned to FC",
  SHIPPED: "Shipped"
};

export function findOrderEnumNames(value) {
  return orderFulfillmentEnumNames[
    Object.keys(orderFulfillmentEnumNames).find(key => key === value)
  ];
}

export function translateBoolean(value: boolean, intl: IntlShape): string {
  return value
    ? intl.formatMessage(commonMessages.yes)
    : intl.formatMessage(commonMessages.no);
}
